import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from "moment";
import { NavigationContext } from '../../context/navigation-context'
import { NotificationManager } from 'react-notifications'
import SearchFilter from '../../components/Filter/SearchFilter'

const PAS = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()

  const { setHeaderData } = useContext(NavigationContext)

  const defaultFilter = {
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    name: "PAS",
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    zeroPA: "null",
    telemetry: "null",
    machineId: null,
    machineName: "",
    userId: null,
    userName: "",
    machineTags: { id: [], name: [] },
  }

  const reportList = [
    { reportId: 5, reportColor: 'primary' },
    { reportId: 6, reportColor: 'danger' },
  ].filter(Boolean);

  const [PAS, setPAS] = useState([]);
  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    Created: "DESC",
    MachineFullName: "ASC",
    Total: "DESC",
    KP: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    getPAS(next);
  };

  const getMachineIdsByTags = (machineTagIds) => {
    return new Promise((resolve, reject) => {
      fetchMssqlApi(
        "tags/getMachineIdsByTags",
        { method: "POST", hideNotification: true, data: { machineTagIds } },
        (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
        (err) => reject(err)
      );
    });
  };

  const getPAS = async (f) => {
    let machineIds = "[]";
    if (f?.machineTags?.id?.length > 0) { machineIds = await getMachineIdsByTags(f.machineTags.id)} 
    if (f?.machineId) {const arr = JSON.parse(machineIds); arr.push(Number(f.machineId)); machineIds = JSON.stringify(arr);}
    fetchMssqlApi(
      "pa-pas",
      {
        method: "POST",
        hideNotification: true,
        data: {
          isZeroTotal: f.zeroPA === "null" ? null : f.zeroPA === "true",
          isTelemetry: f.telemetry === "null" ? null : f.telemetry === "true",
          fromCreateDateTime: f.dateTimeRangeFrom,
          toCreateDateTime: f.dateTimeRangeTo,
          machineIds,
          createUserId: f.userId,
          sortBy: f.sortBy,
        },
      },
      (response) => {
        setPAS(response || []);
      }
    );
  };

  useEffect(() => {
    setHeaderData({
      text: TRL_Pack.pa.pas
    });
  }, [])

  useEffect(() => {
    const screenHeight = window.innerHeight
    const reservedSpace = 350
    const visibleRows = Math.floor((screenHeight - reservedSpace) / 40)

    setFilter(prev => ({
      ...prev,
      rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
    }))
  }, [])

  const getPASUI = () => {
    if (PAS != null) {
      let temp = JSON.parse(JSON.stringify(PAS));

      temp.map(PAS => {
        delete PAS.MachineCoinInventoryId
        delete PAS.VisitId
        delete PAS.WarehouseOperationId
      })
      // console.log(salesdoc)

      return (
        <div>
          <div>
            <SearchFilter
              filterName="PAS"
              defaultFilter={defaultFilter}
              reportList={reportList}
              onFilterChange={(f) => setFilter(f)}
              onSettingsChange={(s) => setSettingsFilter(s)}
              search={getPAS}
              totalCount={PAS.slice(
                (filter.page - 1) * rowsPerPage,
                filter.page * rowsPerPage
                ).length}
              dataList={PAS}
            />
            <div className="border">
                <div
                  className="overflow-auto custom-scroll"
                  style={{
                    maxHeight: `${
                      window.innerHeight - 146
                    }px`,
                    overflowY: "auto",
                  }}
                >
                {PAS.length ? (
                  <table className="table table-striped">
                    <thead>
                      <tr className='text-center headers-color'>
                        <td
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("Created")}
                        >
                          Nr PA<br />Czas, Żródło{arrow("Created")}
                        </td>
                        <td
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("MachineFullName")}
                        >
                          {TRL_Pack.pa.machineFullname}{arrow("MachineFullName")}
                        </td>
                        <td
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("Total")}
                        >
                          {TRL_Pack.pa.total}{arrow("Total")}
                        </td>
                        <td
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("KP")}
                        >
                          {TRL_Pack.pa.machineCoinInventory}{arrow("KP")}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {PAS
                        .slice(
                          (filter.page - 1) * rowsPerPage,
                          filter.page * rowsPerPage
                        )
                        .map((entry, idx) => (
                          <tr className='text-center' key={idx}>
                            <td className="">
                              <div className='d-flex flex-column justify-content-center align-items-center'>
                                <Link to={`/pa/${entry.WarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-secondary">
                                  PA {entry.WarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}</Link></div>
                              {entry.Created}
                            </td>
                            <td><Link to={`/machine/${entry.MachineId}`} className="btn btn-sm btn-outline-link">{entry.MachineFullName}</Link></td>
                            <td>
                              <div className="btn text-nowrap">{String(Intl.NumberFormat('pl-PL', {style: "currency", currency: "PLN"}).format(entry.Total)) || ""}</div>
                            </td>
                            <td>{!!entry.MachineCoinInventoryId && (
                              <span className="btn text-nowrap btn-sm btn-outline-success"> KP {entry.WarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}</span>)}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <NoResults />
                )
                }
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <div>
        {getPASUI()}
      </div>
    </>
  )
}

export default PAS;